// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "phone_number".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { phoneNumberProviderValues, phoneNumberStatusValues, voiceNumberAssignmentValues } from '@borradh-workspace/labels';
/** Response atom for the "phone_number" table (1:1 with a DB row, on the wire). */
export const phoneNumberAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string().nullable(),
    assignment: z.enum(voiceNumberAssignmentValues),
    locationId: z.string().nullable(),
    number: z.string(),
    label: z.string().nullable(),
    provider: z.enum(phoneNumberProviderValues),
    providerNumberId: z.string().nullable(),
    status: z.enum(phoneNumberStatusValues),
    supportsOutbound: z.boolean(),
    lastUsedAt: z.string().datetime().nullable(),
    countryCode: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=phoneNumber.js.map